import { deleteToken, getMessaging, getToken } from 'firebase/messaging';
import configs from '@/root/configs';
import { firebaseApp, firebaseVapidKey } from '../../firebase.config';
import { devLog } from '@/utils/dev';
import {
  hasFreshExistingFCMTokenInStorage,
  removeFCMTokenStorage,
  setFCMTokenStorage,
  shouldRemoveFCMTokenStorage,
} from './storage';

const messaging = getMessaging(firebaseApp);

export const maybeCreateFCMToken = async (
  userKey: string,
  onNewCreate: (__fcmToken: string) => Promise<void>
) => {
  if (Notification.permission === 'denied') {
    // return Promise.reject({
    //   displayMode: 'Toast',
    //   message: 'تنظیمات سیستم مربوط به مجوز دریافت نوتیفیکیشن را بررسی نمایید.',
    // });
    return;
  }

  // اگر با یک یوزر جدید وارد شد دیتای قبلی باید پاک بشه
  if (shouldRemoveFCMTokenStorage(userKey)) {
    await deleteFCMTokenData();
  }

  const permission = await requestPermission();
  devLog('Firebase@Permission', permission);
  if (permission !== 'granted') {
    return Promise.reject({
      displayMode: 'Toast',
      message: 'اجازه دسترسی به نوتیفیکیشن توسط کاربر داده نشد.',
    });
  }

  const fcmToken = await getFCMToken();

  if (!hasFreshExistingFCMTokenInStorage(userKey, fcmToken)) {
    devLog('Firebase@Token', fcmToken);
    await onNewCreate(fcmToken);
    setFCMTokenStorage(userKey, fcmToken);
  }
};

export const getFCMToken = async () => {
  return await getToken(messaging, {
    vapidKey: firebaseVapidKey,
    serviceWorkerRegistration: await navigator.serviceWorker.register(
      `/${configs.serviceWorker}`
    ),
  });
};

export const deleteFCMTokenData = async () => {
  try {
    removeFCMTokenStorage();
    await deleteToken(messaging);
  } catch {}
};

// https://stackoverflow.com/a/77165278/6937189
export const requestPermission = async () => {
  return new Promise((resolve) => {
    let iterations = 0;
    const timeoutId = setInterval(() => {
      iterations++;
      if (Notification.permission === 'granted' || iterations >= 20) {
        handleComplete(Notification.permission);
      }
    }, 5000);

    const handleComplete = (permission: NotificationPermission) => {
      clearInterval(timeoutId);
      resolve(permission);
    };

    Notification.requestPermission(handleComplete)?.then?.(handleComplete);
  });
};
